import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import Collectiontiles from "./components/Collectiontiles";
import HomepageStores from "./components/HomepageStores";
import Guidelines from "./components/Guidelines";
import Clairinfinity from "./components/Clairinfinity";
import QuickLinksMobile from "./components/QuickLinksMobile";
import QuickLinks from "./components/QuickLinks";
import Homemagazine from "./components/Homemagazine";
import CuratedCollections from "./components/CuratedCollections";
import LabeledCollections from "./components/LabeledCollections";
import {
    getForYouHomepageData,
    getHomeDataDetails,
    getShopifyDataFromFavoriteList
} from "../actionCreators/appAC";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {LazyLoadImage} from "react-lazy-load-image-component";
import config from "../../config";
import {extractUserName, getCookie, getImageBySizeFromCDN} from "../common/utils";
import PersonalizedCartModule from "./components/PersonalizedCartModule";
import {openShopifyCart} from "../actionCreators/shopifyAC";
import PersonalizedCarouselModule from "./components/PersonalizedCarouselModule";
import {authCheck} from "../common/utils";
import {getRecentlyViewed} from "../actionCreators/pdpAC";
import "./Homepage.scss";
import LazyLoad from "react-lazyload";
import TierDetails from "./components/TierDetails";

class Homepage extends React.Component {
    getQuickLinks() {
        return [
            {
                name: "CHANEL",
                url: `${config.host_rebag_shop}/collections/chanel`
            },
            {
                name: "GUCCI",
                url: `${config.host_rebag_shop}/collections/gucci`
            },
            {
                name: "LOUIS VUITTON",
                url: `${config.host_rebag_shop}/collections/louis-vuitton`
            },
            {
                name: "PRADA",
                url: `${config.host_rebag_shop}/collections/prada`
            },
            {
                name: "DIOR",
                url: `${config.host_rebag_shop}/collections/christian-dior`
            },
            {
                name: "BIRKIN",
                url: `${config.host_rebag_shop}/search?q=Birkin&pf_st_availability_hidden=true`
            },
            {
                name: "FENDI",
                url: `${config.host_rebag_shop}/collections/fendi`
            },
            {
                name: "YSL",
                url: `${config.host_rebag_shop}/search?q=YSL&pf_st_availability_hidden=true`
            },
            {
                name: "HERMES",
                url: `${config.host_rebag_shop}/collections/hermes`
            },
            {
                name: "NEVERFULL",
                url: `${config.host_rebag_shop}/search?q=Neverfull&pf_st_availability_hidden=true`
            },
        ]
    }

    componentDidMount() {
        if(authCheck()){
            this.props.getShopifyDataFromFavoriteList();
            this.props.getRecentlyViewed(true);
            this.props.getForYouHomepageData();
        }
    }

    render() {

        const {
            home_details, mobile_big, mobile_medium, mobile_small, user_profile,
            cart_count, checkout, openShopifyCart, for_you_products, recently_viewed_products,
            shopify_favorites_list, user_logged_in, init, isInternational, selectedCountry
        } = this.props;

        const user_name = user_profile ? extractUserName(user_profile) : '';
        const force_homepage_hero = getCookie('force_homepage_hero');
        const show_personalized_carousel = (for_you_products && for_you_products.items.length > 0) || (shopify_favorites_list && shopify_favorites_list.length > 0) || (recently_viewed_products && recently_viewed_products.length > 0);

        return (
            <Container className="homepage">
                {user_logged_in && !force_homepage_hero &&
                    <Row className="homepage__personalization">
                        <Col>
                            <div className="homepage-personalization__title">
                                Welcome, {user_name}
                            </div>
                            {cart_count > 0 &&
                                <PersonalizedCartModule
                                    cart_count={cart_count}
                                    checkout={checkout}
                                    openShopifyCart={openShopifyCart}
                                    isInternational={isInternational}
                                    selectedCountry={selectedCountry}
                                />
                            }
                            {show_personalized_carousel &&
                                <PersonalizedCarouselModule
                                    for_you_products={for_you_products}
                                    recently_viewed_products={recently_viewed_products}
                                    shopify_favorites_list={shopify_favorites_list}
                                />
                            }
                        </Col>
                    </Row>
                }
                <Row className="homepage__collection-tiles">
                    <Col>
                        <Collectiontiles
                            home_details={home_details}
                            mobile_big={mobile_big}
                            mobile_small={mobile_small}
                        />
                    </Col>
                </Row>
                <Row className="homepage__quick-links">
                    <Col>
                        {mobile_big ?
                            <QuickLinksMobile
                                quick_links={this.getQuickLinks()}
                            />
                            :
                            <QuickLinks
                                quick_links={this.getQuickLinks()}
                            />
                        }
                    </Col>
                </Row>
                <Row className="homepage__guidelines">
                    <Col>
                        <Guidelines />
                    </Col>
                </Row>
                <Row className="homepage__labeled-collections">
                    <Col>
                        <LazyLoad height={600} offset={100} once={true}>
                            <LabeledCollections />
                        </LazyLoad>
                    </Col>
                </Row>
                <Row className="homepage__clair-infinity">
                    <Col>
                        <Clairinfinity />
                    </Col>
                </Row>
                <Row className="homepage__curated-collections">
                    <Col>
                        <LazyLoad height={600} offset={100} once={true}>
                            <CuratedCollections />
                        </LazyLoad>
                    </Col>
                </Row>
                <Row className="homepage__stores">
                    <Col>
                        <LazyLoad height={600} offset={100} once={true}>
                            <HomepageStores />
                        </LazyLoad>
                    </Col>
                </Row>
                <Row className="homepage__the-vault">
                    <Col>
                        <Homemagazine />
                    </Col>
                </Row>
                <Row className="homepage__discover">
                    <Col>
                        <div className="d-t-f-c">
                            <div>
                                <Row>
                                    <Col>
                                        <div className="img-container">
                                            <LazyLoadImage
                                                alt="Discover The Full Catalog"
                                                title="Discover The Full Catalog"
                                                src={`${config.MEDIA_URL}/img/${mobile_medium ? "homepage-discover-catalog-mob-02-16-2023.jpg" : "homepage-discover-catalog-web-02-16-2023.jpg"}`}
                                            />
                                        </div>
                                        <div className="d-t-c">
                                            <h2>DISCOVER THE FULL CATALOG</h2>
                                            <a href={`${config.host_rebag_shop}/collections/new-arrivals?_=pf&pf_st_availability_hidden=true`}>
                                                SHOP ALL <i/>
                                            </a>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}
const mapStateToProps = function (state) {
    const {user_profile} = state.myAccountReducer;
    const {home_details, mobile_big, mobile_medium, mobile_small, for_you_products, user_logged_in, init, isInternational, selectedCountry} = state.appReducer;
    const {cart_count, checkout, recently_viewed_products, shopify_favorites_list} = state.shopifyReducer;
    return {
        home_details, mobile_big, mobile_medium, mobile_small, user_profile,
        cart_count, checkout, for_you_products, recently_viewed_products, shopify_favorites_list, user_logged_in,
        init, isInternational, selectedCountry
    };
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        getHomeDataDetails,
        openShopifyCart,
        getForYouHomepageData,
        getRecentlyViewed,
        getShopifyDataFromFavoriteList
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);

